import { render, staticRenderFns } from "./UserUniversalTile.vue?vue&type=template&id=7c0dcd46&scoped=true&lang=pug&"
import script from "./UserUniversalTile.vue?vue&type=script&lang=js&"
export * from "./UserUniversalTile.vue?vue&type=script&lang=js&"
import style0 from "./UserUniversalTile.vue?vue&type=style&index=0&id=7c0dcd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0dcd46",
  null
  
)

export default component.exports